import { Wrapper } from '../../components/wrapper.component';
import { OnInit, ViewChild, ChangeDetectorRef, Component } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from 'src/app/helpers/helpers';
import { tableFilterTypes } from 'src/app/store/performers.era';
import { saveTable } from '../performers/performerSharedFunctions';
import { QuoteTableData, quoteColumns } from 'src/app/helpers/table-column-types';
import { TableColumn, TableMenuItem } from 'src/app/helpers/table.data';
import { accountQuoteColumnsById, allDefaultAccountQuotesColumns } from 'src/app/helpers/table-helpers';
import { NestedTableComponent } from './../../components/nested-table/nested-table.component';
import { accountQuotesTableReselector } from '../../store/reselectors/quotes.reselector';
import { JoiAccount } from 'globals/store/accounts.data';
import { budgetAccountSelector } from '../../store/reselectors/accounts.reselector';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { CommonModule } from '@angular/common';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'account-budget-quotes',
    templateUrl: './account-budget-quotes.html',
    styleUrls: ['./budget-quotes.scss'],
    standalone: true,
    imports: [NestedTableComponent, CommandMenuComponent, CommonModule ]
})
export class AccountBudgetQuotesComponent extends Wrapper<AccountBudgetQuotesComponent> implements OnInit {
  filterPage = filterPageTypes.accountQuotes
  filterType = tableFilterTypes.QuotesTable
  quoteColumns = quoteColumns
  columnData: TableColumn[] = allDefaultAccountQuotesColumns
  columnsById: { [id: string]: TableColumn } = accountQuoteColumnsById
  tableData: QuoteTableData[] = []
  tableRowsById: { [id:string]: QuoteTableData } = {}
  selectedIds: string[] 
  busy = false
  account: JoiAccount
  menuItems: TableMenuItem[] = []
  condensed: boolean
  traceNames = traceNames
  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<QuoteTableData>

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.uiService.changePageTitle("Account Quotes", true)
    this.selectCallback<{
      quoteTableData: QuoteTableData[];
      quoteTableRowsById: {
          [key: string]: QuoteTableData;
      };
    }, any>(accountQuotesTableReselector, null, data => {
      if (!data) {
        this.tableData = [] // for when the last is deleted
        return
      }
      const { quoteTableData, quoteTableRowsById } = data
      this.tableData = quoteTableData
      this.tableRowsById = quoteTableRowsById
    })
    this.loadCondensed()
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
    this.selectProp(budgetAccountSelector, null, 'account')
  }

  ngOnInit() {
  }


  saveTable() {
    saveTable('quotes', `${this.account.title} quotes table`, this.dialog, this.nestedTable)
  }

  selectIds(ids: Set<string>) {
    this.selectedIds = Array.from(ids)
  }

  async manageQuote({ id }: QuoteTableData, manualResourceId = null) {
    console.log("NOT IMPLEMENTED", { id, manualResourceId })
  }

  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false)
  }

}
